export enum UiServerDictionaryType {
  // server dictionaries
  // TODO: добавить после появления серверных словарей
}

export enum UiLocalDictionaryType {
  ResearchWorkflowStatusNames = 'research_workflow_status_names',
  VideoStatusNames = 'video_status_names',
}

export const UiDictionaryType = { ...UiServerDictionaryType, ...UiLocalDictionaryType };
export type UiDictionaryType = UiServerDictionaryType | UiLocalDictionaryType;
